import React from 'react';
import { Flex, FlexProps } from '@chakra-ui/react';
import MemberCard from 'assets/jika-club-card.png';
import { UndraggableImage } from 'components/shared/UndraggableImage';

interface Props {
  children: React.ReactNode;
}

export const Condition = React.memo(
  ({ children, ...otherProps }: Props & FlexProps) => {
    return (
      <Flex
        width={{ base: 300, sm: 340, md: 320, lg: 350 }}
        alignItems="center"
        m={2}
        {...otherProps}
      >
        <UndraggableImage
          src={MemberCard}
          width="100%"
          maxWidth={{ base: 140, sm: 180, md: 140, lg: 160 }}
          mr={4}
          position="relative"
          top={2}
        />
        <Flex flexDirection="column">{children}</Flex>
      </Flex>
    );
  },
);
